import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = (showDrawer: boolean) =>
  makeStyles((theme: Theme) => ({
    container: {
      rowGap: theme.spacing(5),
    },
    inputLabel: {
      fontSize: "12px",
      textTransform: "uppercase",
      fontWeight: "bold",
      color: "#666",
      marginLeft: theme.spacing(1.5),
    },
    input: {
      borderRadius: theme.spacing(1),
    },
    button: {
      backgroundColor: "#000",
      color: "white",
      columnGap: "8px",
      alignItems: "center",
    },
    bannerButtonsContainer: {
      display: "flex",
      margin: theme.spacing(2),
      spacing: theme.spacing(1),
      width: theme.spacing(11),
      justifyContent: "space-between",
    },
    updateBannerButton: {
      backgroundColor: "#242424",
      width: "40px",
      height: "40px",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#242424",
        color: "white",
        opacity: 0.6,
      },
    },
    deleteBannerButton: {
      backgroundColor: "#EB5757",
      width: "40px",
      height: "40px",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#EB5757",
        color: "white",
        opacity: 0.6,
      },
    },
    footer: {
      position: "fixed",
      bottom: 0,
      left: showDrawer ? theme.spacing(39) : theme.spacing(14),
      right: theme.spacing(2.5),
      width: "auto",
      borderTop: `1px solid #DBDBDB`,
      borderLeft: `1px solid #DBDBDB`,
      borderRight: `1px solid #DBDBDB`,
      borderTopLeftRadius: theme.spacing(1),
      borderTopRightRadius: theme.spacing(1),
      justifyContent: "flex-end",
      padding: theme.spacing(2),
      boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.1)",
      backgroundColor: "white",
      zIndex: 1000,
      paddingTop: theme.spacing(2),
      flexDirection: "row",
    },
  }));

export default useStyles;
